import { render, staticRenderFns } from "./ScanError.vue?vue&type=template&id=28072842&scoped=true&"
import script from "./ScanError.vue?vue&type=script&lang=js&"
export * from "./ScanError.vue?vue&type=script&lang=js&"
import style0 from "./ScanError.vue?vue&type=style&index=0&id=28072842&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28072842",
  null
  
)

export default component.exports